function Square({ height = 21 }) {
  return (
    <svg height={height} viewBox="1 0.901 53.201 53.199">
      <g id="layer3">
        <g id="g3486">
          <path
            id="path3010"
            d="M45.333,0.901H9.868C4.992,0.901,1,4.891,1,9.769v35.466    C1,50.109,4.992,54.1,9.868,54.1h35.466c4.876,0,8.868-3.99,8.868-8.865V9.769C54.201,4.891,50.209,0.901,45.333,0.901     M44.527,41.609c0,1.55-1.269,2.815-2.82,2.815H13.492c-1.55,0-2.82-1.266-2.82-2.815V13.395c0-1.55,1.27-2.82,2.82-2.82h28.215    c1.551,0,2.82,1.27,2.82,2.82V41.609z M34.857,33.143c0,0.889-0.726,1.612-1.61,1.612H21.962c-0.887,0-1.61-0.724-1.61-1.612    V21.859c0-0.887,0.723-1.611,1.61-1.611h11.284c0.885,0,1.61,0.725,1.61,1.611V33.143z"
          />
        </g>
      </g>
    </svg>
  );
}

export default Square;
